export enum DOCUMENTS_DB {
  USERS_ADMIN = 'users_admin',
  USERS = 'users',
  NEWSLETTERS = 'newsletters',
  POLICIES = 'policies',
  REPORTS = 'reports',
  RELEASES = 'releases',
  CRITICAL_STANDARS = 'critical_standars',
  PODCASTS = 'podcasts',
  VIDEOS = 'videos',
  LINKS = 'links',
  GALLERIES = 'galleries',
  BANNERS = 'banners',
  HISTORICAL = 'historical',
  CONFIG = 'config',
  ADMIN_LOGS = 'admin_logs',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  CAMPAIGNS = 'campaigns',
  AUDIENCES = 'audiences',
}
